import { cn } from '@/utils/cn'
import Image from 'next/image'
import { HTMLAttributes } from 'react'
import { ProductShareButton } from '../../product-share-button'

export type ProductThumbnailUIProps = {
  imageUrl: string
  isSoldOut: boolean
  isSoftDeleted: boolean
  showBanner: boolean
  productTitle: string
}

export const ProductThumbnailUI = ({
  className,
  imageUrl,
  isSoldOut,
  isSoftDeleted,
  showBanner,
  productTitle,
  ...props
}: ProductThumbnailUIProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className="relative">
      <div
        className={cn(
          'relative mx-auto flex aspect-square w-4/5 justify-center md:aspect-auto',
          className,
        )}
        {...props}
      >
        {showBanner && (
          <div className="absolute top-0 z-10 h-[44px] w-full bg-black pt-[13px] text-center text-body-02-bold text-white">
            <span className="text-primary">똑소 타이밍</span>이에요. 구매를
            서두르세요!
          </div>
        )}
        <div className="md:relative md:size-[536px]">
          <Image
            src={imageUrl}
            alt={`똑소 - 쿠팡 가격 변동 추적 알림 '${productTitle}'에 대한 이미지`}
            fill
            unoptimized
          />
        </div>
        {isSoldOut && (
          <div className="absolute left-0 top-0 flex size-full items-center justify-center bg-dim-2 text-white">
            <div className="text-center">
              {isSoftDeleted ? (
                <span className="text-section-title">
                  {"'알림 받기'"} 를 누르시면
                  <br />
                  상품이 원하는 가격에 도달했을때 알림을 보내드려요
                </span>
              ) : (
                <>
                  <span className="mb-[16px] inline-block text-title-01 font-normal">
                    품절
                  </span>
                  <br />
                  <span className="text-section-title">
                    재입고 됐을 때 알림을 받아보세요!
                  </span>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="absolute bottom-5 right-5">
        <ProductShareButton />
      </div>
    </div>
  )
}
